module.exports = __webpack_public_path__ + "img/trafficlight1.b83d4f24.png";